const image1 = '/exampleNftThumbnails/1.png';
const image2 = '/exampleNftThumbnails/2.png';
const image3 = '/exampleNftThumbnails/3.png';
const image4 = '/exampleNftThumbnails/4.png';

export const getRandomImage = (index: number): string => {
  const images = [
    image1,
    image2,
    image1,
    image3,
    image4,
    image1,
    image4,
    image3,
    image2,
    image4,
    image2,
    image3,
  ];

  return images[index];
};
